"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GWTAUDIO_MUTED = exports.GWTAUDIO_100 = exports.AUDIO_SETTINGS_DEFAULT = void 0;
var AUDIO_SETTINGS_DEFAULT = exports.AUDIO_SETTINGS_DEFAULT = {
  audioVolume: {
    level: 0,
    muted: true
  },
  audioOffset: {
    offset: 0
  }
};
var GWTAUDIO_MUTED = exports.GWTAUDIO_MUTED = {
  audioVolume: {
    level: 0,
    muted: true
  },
  audioOffset: {
    millis: 0
  }
};
var GWTAUDIO_100 = exports.GWTAUDIO_100 = {
  audioVolume: {
    level: 100,
    muted: false
  },
  audioOffset: {
    millis: 0
  }
};